webpackJsonp([114276838955818,60335399758886],{

/***/ 211:
/***/ (function(module, exports) {

	module.exports = {"layoutContext":{}}

/***/ }),

/***/ 539:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _index = __webpack_require__(556);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _layoutIndex = __webpack_require__(211);
	
	var _layoutIndex2 = _interopRequireDefault(_layoutIndex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(_index2.default, _extends({}, props, _layoutIndex2.default));
	};
	
	module.exports = exports["default"];

/***/ }),

/***/ 7140:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxNyIgaGVpZ2h0PSIzMiIgdmlld0JveD0iMCAwIDE3IDMyIiB4PSIyNDAiPjxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik0xNS42OTUgMTcuMzcxbC43NjItNS42MzhoLTUuNjM4VjguMDc2YzAtMS42NzYuNDU3LTIuNzQzIDIuODk1LTIuNzQzaDMuMDQ4Vi4xNTJjLS42MSAwLTIuNDM4LS4xNTItNC41NzEtLjE1Mi00LjI2NyAwLTcuMzE0IDIuNTktNy4zMTQgNy40Njd2NC4yNjdILjAwMXY1LjYzOGg0Ljg3NnYxNC42MjloNS45NDNWMTcuMzcyaDQuODc2eiIvPjwvc3ZnPgo="

/***/ }),

/***/ 7141:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMiIgaGVpZ2h0PSIzMiIgdmlld0JveD0iMCAwIDMyIDMyIiB4PSI2NzIuMDA3MTAwOTE2MDAyIiBpZD0ic3ZnXzE2OCIgeT0iMC41NjUwMDA1MzQwNTc2MTcyIj48cGF0aCBmaWxsPSIjZmZmIiBkPSJNNC4xMTQgMGgyMy43NzFhNC4wOTcgNC4wOTcgMCAwIDEgNC4xMTQgNC4xMTR2MjMuNzcxYTQuMDk3IDQuMDk3IDAgMCAxLTQuMTE0IDQuMTE0SDQuMTE0QTQuMDk3IDQuMDk3IDAgMCAxIDAgMjcuODg1VjQuMTE0QTQuMDk3IDQuMDk3IDAgMCAxIDQuMTE0IDB6bTE5LjIgMy41MDVjLS43NjIgMC0xLjM3MS42MS0xLjM3MSAxLjM3MXYzLjUwNWMwIC43NjIuNjEgMS4zNzEgMS4zNzEgMS4zNzFoMy42NTdjLjc2MiAwIDEuMzcxLS42MSAxLjM3MS0xLjM3MVY1LjAyOWMwLS43NjItLjYxLTEuMzcxLTEuMzcxLTEuMzcxaC0zLjY1N3ptNS4wMjkgMTAuMDU3SDI1LjZjLjMwNS45MTQuMzA1IDEuODI5LjMwNSAyLjc0MyAwIDUuMzMzLTQuNDE5IDkuNi05LjkwNSA5LjZzLTkuOTA1LTQuMjY3LTkuOTA1LTkuNmMwLS45MTQuMTUyLTEuODI5LjQ1Ny0yLjc0M0gzLjUwNHYxMy41NjJjMCAuNzYyLjYxIDEuMjE5IDEuMjE5IDEuMjE5aDIyLjI0OGMuNzYyIDAgMS4yMTktLjYxIDEuMjE5LTEuMjE5VjEzLjU2MnpNMTYgOS43NTJjLTMuNTA1IDAtNi40IDIuNzQzLTYuNCA2LjI0OHMyLjg5NSA2LjI0OCA2LjQgNi4yNDhjMy41MDUgMCA2LjQtMi43NDMgNi40LTYuMjQ4UzE5LjUwNSA5Ljc1MiAxNiA5Ljc1MnoiIGlkPSJzdmdfMTY5Ij48L3BhdGg+PC9zdmc+Cg=="

/***/ }),

/***/ 7142:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMiIgaGVpZ2h0PSIzMiIgdmlld0JveD0iMCAwIDMyIDMyIiB4PSI1NzYuMDA3MTAwOTE2MDAyIiBpZD0ic3ZnXzE2MiIgeT0iMC41NjUwMDA1MzQwNTc2MTcyIj48cGF0aCBmaWxsPSIjZmZmIiBkPSJNMjguMDM4IDBIMy45NjJDMS44MjkgMCAwIDEuODI5IDAgMy45NjJ2MjQuMDc2QzAgMzAuMTcxIDEuODI5IDMyIDMuOTYyIDMyaDI0LjA3NkMzMC4xNzEgMzIgMzIgMzAuMTcxIDMyIDI4LjAzOFYzLjk2MkMzMiAxLjgyOSAzMC4xNzEgMCAyOC4wMzggMHptLTUuMTgxIDI0Ljk5Yy0uOTE0LjQ1Ny0xLjY3Ni43NjItMi40MzguOTE0cy0xLjUyNC4zMDUtMi4yODYuMzA1Yy0uOTE0IDAtMS44MjktLjE1Mi0yLjU5LS4zMDUtLjc2Mi0uMzA1LTEuMzcxLS42MS0xLjgyOS0xLjA2N3MtLjkxNC0uOTE0LTEuMDY3LTEuMzcxYy0uMzA1LS42MS0uNDU3LTEuMzcxLS40NTctMi4yODZ2LTcuMzE0SDkuOTA0di0zLjA0OGMuNzYyLS4zMDUgMS41MjQtLjYxIDIuMTMzLTEuMjE5YTQuNzUxIDQuNzUxIDAgMCAwIDEuMzcxLTEuNjc2Yy4zMDUtLjc2Mi42MS0xLjUyNC43NjItMi43NDNoMy4wNDh2NS4zMzNoNS4wMjl2My4zNTJoLTUuMDI5djUuMzMzYzAgMS4yMTkgMCAxLjk4MS4xNTIgMi4yODZzLjMwNS42MS43NjIuNzYyYTIuOTM4IDIuOTM4IDAgMCAwIDEuNTI0LjQ1N2MxLjA2NyAwIDIuMTMzLS4zMDUgMy4yLTEuMDY3djMuMzUyeiIgaWQ9InN2Z18xNjMiPjwvcGF0aD48L3N2Zz4K"

/***/ }),

/***/ 7143:
/***/ (function(module, exports) {

	module.exports = "data:image/svg+xml;base64,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"

/***/ }),

/***/ 674:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"footer":"src-components-Footer----footer-module---footer---31Fwu"};

/***/ }),

/***/ 549:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _footerModule = __webpack_require__(674);
	
	var _footerModule2 = _interopRequireDefault(_footerModule);
	
	var _fb = __webpack_require__(7140);
	
	var _fb2 = _interopRequireDefault(_fb);
	
	var _instagram = __webpack_require__(7141);
	
	var _instagram2 = _interopRequireDefault(_instagram);
	
	var _youtube = __webpack_require__(7143);
	
	var _youtube2 = _interopRequireDefault(_youtube);
	
	var _twitterText = __webpack_require__(7142);
	
	var _twitterText2 = _interopRequireDefault(_twitterText);
	
	var _semanticUiReact = __webpack_require__(24);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Brand = function Brand() {
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(
	      'div',
	      { className: _footerModule2.default.declare },
	      _react2.default.createElement(
	        'span',
	        null,
	        '2018 \xA9 All Rights Reserved.'
	      )
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: _footerModule2.default.declare },
	      _react2.default.createElement(
	        'span',
	        null,
	        'Uni Village Education'
	      )
	    )
	  );
	};
	
	var Hidden = function Hidden(_ref) {
	  var col = _ref.col;
	
	  var hidden = { visibility: 'hidden' };
	  return _react2.default.createElement(
	    Span,
	    { columns: 8 },
	    _react2.default.createElement(
	      'div',
	      { style: hidden },
	      '-'
	    )
	  );
	};
	
	var Footer = function Footer() {
	  var icons = [{ icon: _fb2.default, url: 'https://fb.me/univillage.co' }, { icon: _instagram2.default, url: 'https://www.instagram.com/univillageedu/' }, { icon: _youtube2.default, url: 'https://www.youtube.com/channel/UCfNzjgBZzcQr5axNjdPanXQ' }, { icon: _twitterText2.default, url: 'https://twitter.com/univillageedu' }];
	  var links = [{ title: 'About', url: '/' }, { title: 'Contact', url: '/' }, { title: 'Blog', url: '/' }, { title: 'Privacy', url: '/privacy' }];
	
	  return _react2.default.createElement(
	    _semanticUiReact.Container,
	    { fluid: true, textAlign: 'center', className: _footerModule2.default.footer },
	    _react2.default.createElement(
	      _semanticUiReact.Grid,
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Grid.Row,
	        null,
	        _react2.default.createElement(_semanticUiReact.Grid.Column, { width: 2 }),
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Column,
	          { width: 12 },
	          _react2.default.createElement(
	            _semanticUiReact.List,
	            { horizontal: true, size: 'tiny' },
	            icons.map(function (_ref2, i) {
	              var icon = _ref2.icon,
	                  url = _ref2.url;
	
	              return _react2.default.createElement(
	                _semanticUiReact.List.Item,
	                { key: "logo-" + i },
	                _react2.default.createElement(_semanticUiReact.Image, { src: icon, href: url })
	              );
	            })
	          )
	        ),
	        _react2.default.createElement(_semanticUiReact.Grid.Column, { width: 2 })
	      ),
	      _react2.default.createElement(
	        _semanticUiReact.Grid.Row,
	        null,
	        _react2.default.createElement(_semanticUiReact.Grid.Column, { width: 2 }),
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Column,
	          { width: 12 },
	          _react2.default.createElement(
	            _semanticUiReact.List,
	            { horizontal: true, size: 'tiny' },
	            links.map(function (_ref3, i) {
	              var title = _ref3.title,
	                  url = _ref3.url;
	
	              return _react2.default.createElement(
	                _semanticUiReact.List.Item,
	                { key: "link-" + i },
	                _react2.default.createElement(
	                  'p',
	                  null,
	                  title
	                )
	              );
	            })
	          )
	        ),
	        _react2.default.createElement(_semanticUiReact.Grid.Column, { width: 2 })
	      )
	    )
	  );
	};
	
	exports.default = Footer;
	module.exports = exports['default'];

/***/ }),

/***/ 675:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"container":"src-components-Header----header-module---container---TXsPj"};

/***/ }),

/***/ 550:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(38);
	
	var _logoLowRes = __webpack_require__(7144);
	
	var _logoLowRes2 = _interopRequireDefault(_logoLowRes);
	
	var _semanticUiReact = __webpack_require__(24);
	
	var _headerModule = __webpack_require__(675);
	
	var _headerModule2 = _interopRequireDefault(_headerModule);
	
	var _utils = __webpack_require__(36);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Header = function (_React$Component) {
	  _inherits(Header, _React$Component);
	
	  function Header(props) {
	    _classCallCheck(this, Header);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));
	
	    _this.handleUpdate = function (e, _ref) {
	      var calculations = _ref.calculations;
	
	      _this.setState({ calculations: calculations });
	    };
	
	    _this.handleMenuClick = function (name, url) {
	      _this.setState({ activeItem: name });
	      _this.setState({ visible: !_this.state.visible });
	      (0, _gatsbyLink.navigateTo)(url);
	    };
	
	    _this.state = {
	      activeItem: 'none',
	      visible: false,
	      calculations: {
	        direction: 'none',
	        height: 0,
	        width: 0,
	        topPassed: false,
	        bottomPassed: false,
	        pixelsPassed: 0,
	        percentagePassed: 0,
	        topVisible: false,
	        bottomVisible: false,
	        fits: false,
	        passing: false,
	        onScreen: false,
	        offScreen: false
	      }
	    };
	    return _this;
	  }
	
	  Header.prototype.render = function render() {
	    var _this2 = this;
	
	    var breakpoints = [{ width: 800, right: 3, mid: 4, left: 9 }, { width: 1000, right: 3, mid: 5, left: 8 }, { width: 1200, right: 3, mid: 6, left: 7 }, { width: 1400, right: 3, mid: 7, left: 6 }, { width: 1600, right: 3, mid: 7, left: 6 }];
	    var _state = this.state,
	        calculations = _state.calculations,
	        contextRef = _state.contextRef;
	    var width = this.state.calculations.width;
	
	    var links = [{ title: 'HOME', url: '/', icon: 'home' }, { title: 'COURSE', url: '/courses', icon: 'book' }, { title: 'UNIVERSITY', url: '/universities', icon: 'building outline' }, { title: 'SCHOLARSHIP', url: '/scholarships', icon: 'student' }];
	
	    var LongHeader = function LongHeader(_ref2) {
	      var width = _ref2.width;
	      var activeItem = _this2.state.activeItem;
	
	      var _breakpoints$reduce = breakpoints.reduce(function (acc, x) {
	        if (Object.keys(acc).length > 0) {
	          return acc;
	        }
	        if (width < x.width) {
	          return x;
	        }
	        return acc;
	      }, {}),
	          right = _breakpoints$reduce.right,
	          mid = _breakpoints$reduce.mid,
	          left = _breakpoints$reduce.left;
	
	      return _react2.default.createElement(
	        _semanticUiReact.Grid,
	        null,
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Row,
	          { stretched: true },
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Column,
	            { width: right, className: _headerModule2.default.img },
	            _react2.default.createElement(_semanticUiReact.Image, { src: _logoLowRes2.default })
	          ),
	          _react2.default.createElement(_semanticUiReact.Grid.Column, { width: mid }),
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Column,
	            { width: left, className: _headerModule2.default.leftMenu },
	            _react2.default.createElement(
	              _semanticUiReact.Menu,
	              { secondary: true, compact: true },
	              links.map(function (_ref3, y) {
	                var title = _ref3.title,
	                    url = _ref3.url;
	
	                return _react2.default.createElement(_semanticUiReact.Menu.Item, { key: "menu-" + y, name: title,
	                  active: activeItem === title, onClick: function onClick() {
	                    return _this2.handleMenuClick(title, url);
	                  }, href: (0, _utils.slash)(url) });
	              })
	            )
	          )
	        )
	      );
	    };
	
	    var toggle = function toggle() {
	      _this2.setState({ visible: !_this2.state.visible });
	      var visible = _this2.state.visible;
	    };
	
	    var SideMenu = function SideMenu() {
	      var visible = _this2.state.visible;
	      return _react2.default.createElement(
	        _semanticUiReact.Grid,
	        { verticalAlign: 'middle' },
	        _react2.default.createElement(
	          _semanticUiReact.Grid.Row,
	          { verticalAlign: 'middle', stretched: true },
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Column,
	            { width: 6 },
	            _react2.default.createElement(_semanticUiReact.Image, { src: _logoLowRes2.default, className: _headerModule2.default.img, size: 'huge' })
	          ),
	          _react2.default.createElement(_semanticUiReact.Grid.Column, { width: 7 }),
	          _react2.default.createElement(
	            _semanticUiReact.Grid.Column,
	            { width: 3 },
	            _react2.default.createElement(_semanticUiReact.Icon, { color: 'blue', name: 'sidebar', size: 'big', onClick: function onClick() {
	                toggle();
	              } }),
	            _react2.default.createElement(
	              _semanticUiReact.Sidebar,
	              { as: _semanticUiReact.Menu, animation: 'overlay', width: 'thin', direction: 'right',
	                visible: visible, icon: 'labeled', vertical: true },
	              _react2.default.createElement(
	                _semanticUiReact.Label,
	                { attached: 'top left' },
	                _react2.default.createElement(_semanticUiReact.Icon, { name: 'close', onClick: function onClick() {
	                    toggle();
	                  } })
	              ),
	              links.map(function (_ref4, y) {
	                var title = _ref4.title,
	                    url = _ref4.url,
	                    icon = _ref4.icon;
	
	                return _react2.default.createElement(
	                  _semanticUiReact.Menu.Item,
	                  { key: "menu-" + y, name: title, onClick: function onClick() {
	                      return _this2.handleMenuClick(title, url);
	                    }, href: (0, _utils.slash)(url) },
	                  _react2.default.createElement(_semanticUiReact.Icon, { name: icon }),
	                  title
	                );
	              }),
	              _react2.default.createElement(
	                _semanticUiReact.Menu.Item,
	                { name: 'info circle' },
	                _react2.default.createElement(_semanticUiReact.Icon, { name: 'info circle' }),
	                'ABOUT US'
	              ),
	              _react2.default.createElement(
	                _semanticUiReact.Menu.Item,
	                { name: 'protect' },
	                _react2.default.createElement(_semanticUiReact.Icon, { name: 'protect' }),
	                'PRIVACY'
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(_semanticUiReact.Divider, { hidden: true })
	      );
	    };
	
	    return _react2.default.createElement(
	      _semanticUiReact.Visibility,
	      { fireOnMount: true, onUpdate: this.handleUpdate },
	      _react2.default.createElement(
	        'div',
	        { className: _headerModule2.default.container },
	        _react2.default.createElement(_semanticUiReact.Divider, { hidden: true }),
	        width > 700 && _react2.default.createElement(LongHeader, { width: width }),
	        width < 700 && _react2.default.createElement(SideMenu, null),
	        _react2.default.createElement(_semanticUiReact.Divider, { hidden: true, fitted: true })
	      )
	    );
	  };
	
	  return Header;
	}(_react2.default.Component);
	
	exports.default = Header;
	module.exports = exports['default'];

/***/ }),

/***/ 7144:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/logo-low-res.03fa82db.png";

/***/ }),

/***/ 66:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.Breadcrumb = exports.Article = exports.Book = exports.Occupation = exports.ContactPoint = exports.Course = undefined;
	
	var _reactHelmet = __webpack_require__(31);
	
	var _reactHelmet2 = _interopRequireDefault(_reactHelmet);
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Course = exports.Course = function Course(name, description, provider) {
	  return {
	    "@context": "http://schema.org",
	    "@type": "Course",
	    name: name,
	    description: description,
	    "provider": {
	      "@type": "Organization",
	      "name": '' + provider
	    }
	  };
	};
	
	var ContactPoint = exports.ContactPoint = function ContactPoint() {
	  return {
	    "@context": "http://schema.org",
	    "@id": "https://www.univillage.co/#Organization",
	    "@type": "Organization",
	    "name": "Uni Village Education",
	    "url": "https://www.univillage.co/",
	    "logo": "https://www.univillage.co/univillage-logo-250x250.png",
	    "contactPoint": [{
	      "@type": "ContactPoint",
	      "telephone": "+60-123129981",
	      "contactType": "customer support",
	      "areaServed": ["MY"]
	    }],
	    "sameAs": ["https://www.facebook.com/univillage.co/", "https://twitter.com/univillageedu", "https://www.youtube.com/channel/UCfNzjgBZzcQr5axNjdPanXQ", "https://www.instagram.com/univillageedu/"]
	  };
	};
	
	var Occupation = exports.Occupation = function Occupation() {
	  return {
	    "@context": "http://schema.org",
	    "@type": "Occupation"
	  };
	};
	
	var Book = exports.Book = function Book() {
	  return {
	    "@context": "http://schema.org",
	    "@type": "Book"
	  };
	};
	
	var Article = exports.Article = function Article(authorName, headline, organization, url, description, images) {
	  return {
	    "@context": "http://schema.org",
	    "@type": "Article",
	    "author": {
	      "@type": "Person",
	      "name": '' + authorName
	    },
	    headline: headline,
	    "publisher": {
	      "@type": "Organization",
	      "name": '' + organization,
	      "logo": {
	        "@type": "ImageObject",
	        "url": '' + url
	      }
	    },
	    "mainEntityOfPage": {
	      "@type": "WebPage",
	      "@id": "https://google.com/article"
	    },
	    "datePublished": '' + new Date(),
	    "dateModified": '' + new Date(),
	    "image": images,
	    description: description,
	    url: url
	  };
	};
	
	var breadcrumbItem = function breadcrumbItem(_ref, idx) {
	  var name = _ref.name,
	      id = _ref.id;
	  return {
	    "@type": "ListItem",
	    "position": idx,
	    "item": {
	      name: name,
	      "@id": id
	    }
	  };
	};
	
	var Breadcrumb = exports.Breadcrumb = function Breadcrumb(breadcrumbList) {
	  return {
	    "@context": "http://schema.org",
	    "@type": "BreadcrumbList",
	    "itemListElement": breadcrumbList.map(breadcrumbItem)
	  };
	};
	
	var StructureData = function StructureData(_ref2) {
	  var meta = _ref2.meta;
	
	  var script = [{
	    'type': 'application/ld+json',
	    'innerHTML': JSON.stringify(meta)
	  }];
	  return _react2.default.createElement(_reactHelmet2.default, { script: script });
	};
	
	exports.default = StructureData;

/***/ }),

/***/ 556:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(3);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(38);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _semanticUiReact = __webpack_require__(24);
	
	var _Footer = __webpack_require__(549);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _Header = __webpack_require__(550);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _reactDom = __webpack_require__(34);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _StructureData = __webpack_require__(66);
	
	var _StructureData2 = _interopRequireDefault(_StructureData);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Template = function (_React$Component) {
	  _inherits(Template, _React$Component);
	
	  function Template() {
	    _classCallCheck(this, Template);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Template.prototype.render = function render() {
	    var contactPoint = (0, _StructureData.ContactPoint)();
	    var Children = this.props.children;
	    var props = this.props;
	    return _react2.default.createElement(
	      'div',
	      null,
	      _react2.default.createElement(
	        _semanticUiReact.Container,
	        null,
	        _react2.default.createElement(_Header2.default, null),
	        _react2.default.createElement(_StructureData2.default, { meta: contactPoint }),
	        _react2.default.createElement(Children, _extends({}, props, { top: this }))
	      ),
	      _react2.default.createElement(_Footer2.default, null)
	    );
	  };
	
	  return Template;
	}(_react2.default.Component);
	
	exports.default = Template;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-index-js-e47b7815db6cf9bac1a3.js